import { parsePhoneNumberFromString, getCountryCallingCode } from "libphonenumber-js";

export const SUPPORTED_COUNTRIES = [
    "IT",
    "FR",
    "DE",
    "ES",
    "GB",
    "CH",
    "AT",
    "BE",
    "NL",
    "PT",
    "US",
    "CA",
];

export const DEFAULT_COUNTRY = "IT";

export function getDialCode(country) {
    return `+${getCountryCallingCode(country)}`;
}

export function toE164(nationalNumber, country) {
    if (!nationalNumber || !country) return null;
    const parsed = parsePhoneNumberFromString(nationalNumber, country);
    if (!parsed || !parsed.isValid()) return null;
    if (!SUPPORTED_COUNTRIES.includes(parsed.country)) return null;
    return parsed.number;
}
